package com.exura.features.userprofile.domain.model

import dev.gitlive.firebase.firestore.CollectionReference
import com.exura.features.newauth.domain.model.ProviderUserRole

data class OrganizationProfile(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val email: String,
    val name: String?,
    val field: String?,
    val patientsContactNumber: String?,
) : ProviderProfile(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    providerRole = ProviderUserRole.ORGANIZATION,
) {
    override fun makeStamp(): Stamp = Stamp(
        signature = name,
        contact = patientsContactNumber,
    )
}
